export class ValidationError {
  constructor(errors, headers) {
    this.code = 400
    this.errors = errors
    this.headers = headers
  }
}

export class TechnicalError {
  constructor(error, status) {
    this.error = error
    this.code = 500
    if (status !== undefined) this.status = status
  }
}

export class UnauthorizedError {
  constructor() {
    this.code = 401
  }
}

export class NotFoundError {
  constructor(response, headers) {
    this.code = 404
    this.response = response
    this.headers = headers
  }
}

export class NotJsonError {
  constructor(response) {
    this.code = 400
    this.response = response
  }
}

export class ForbiddenError {
  constructor(error) {
    this.code = 403
    if (error !== undefined) this.error = error
  }
}

export class TooManyRequestsError {
  constructor(retryAfter, error) {
    this.code = 429
    this.retryAfter = retryAfter
    if (error !== undefined) this.error = error
  }
}

// Optimistic-concurrency conflict (compare-and-set). The layout write's expectedVersion did not
// match the server's current version — the caller refetches, re-exports, and retries once.
export class ConflictError {
  constructor(error) {
    this.code = 409
    this.error = error
  }
}

export class PayloadTooLargeError {
  constructor(error) {
    this.code = 413
    this.error = error
  }
}
